class StickyHeader extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        position: sticky;
        top: 0;
        z-index: 10;
        
        display: block;
        
        background-color: #fff;
      }
    `
  }

  constructor () {
    super()

    this.isTicking = false
    // eslint-disable-next-line
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    // eslint-disable-next-line
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.lastKnownY > 300
      ? this.setAttribute('stuck', '')
      : this.removeAttribute('stuck')
  }
}

if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader)
}
